import { fmtDT } from "@/lib/brand";
import { PriceRows } from "@/components/site/Shared";

export function CheckoutSummary({ car, pickup, ret, quote }) {
  return (
    <aside className="h-fit space-y-5 rounded-3xl border border-black/5 bg-white p-6 lg:sticky lg:top-24" data-testid="checkout-summary">
      <img src={car.images.front} alt={car.name} className="aspect-[3/2] w-full rounded-2xl object-cover" />
      <div>
        <h3 className="font-display text-xl font-semibold">{car.name}</h3>
        <p className="text-sm text-neutral-500">{car.variant} · {car.transmission} · {car.fuel}</p>
      </div>
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div className="rounded-xl bg-neutral-50 p-3"><p className="text-xs text-neutral-500">Pickup</p><p className="font-medium">{fmtDT(pickup)}</p></div>
        <div className="rounded-xl bg-neutral-50 p-3"><p className="text-xs text-neutral-500">Return</p><p className="font-medium">{fmtDT(ret)}</p></div>
      </div>
      {quote && <PriceRows q={quote} />}
    </aside>
  );
}
